import { system } from '@hover/blueprint';
import React from 'react';

import type { VirtualListItemProps } from './types';

export interface VirtualListColumnProps extends VirtualListItemProps {}

/**
 * @todo consider consolidating this with the row version of this component
 */
export const VirtualListColumn = ({
  children,
  mode = 'transform',
  virtualItem: { start, size },
  style,
  ...props
}: VirtualListColumnProps) => {
  const offset =
    mode === 'transform'
      ? { transform: `translateX(${start}px` }
      : { left: `${start}px` };

  return (
    <system.div
      style={{
        // NOTE: we're using inline styling here to avoid the overhead of having
        // Emotion inject and update `<style>` tags for every position and
        // dimensions change applied to the virtualized list item as it scrolls
        position: 'absolute',
        display: 'block',
        top: 0,
        bottom: 0,
        width: `${size}px`,
        ...offset,
        ...style,
      }}
      {...props}
    >
      {children}
    </system.div>
  );
};
